/** @flow */

import {
  GetRtw,
  GetRtwSuccess,
  GetRtwError,
  GetRtwSchema,
  GetRtwSchemaSuccess,
  GetRtwSchemaError,
  NewRtw,
  DuplicateRtwSuccess,
  StartDraftRtwSuccess,
  SetRtwDraft,
  NewRtwAssignments,
  SetRtwAssignments,
  SetRtwEnabled,
  SetRtwStatus,
  SetRtwModalStep,
  SetShowAddRtwModal,
  SetShowEditRtwModal,
  SetShowEditRtwAssignmentsModal,
  SetShowDiscardRtwModal,
  SetShowSubmitRtwModal,
  SetShowDisableRtwModal,
  SetShowCancelRtwModal,
  SetShowCancelDiscardRtwModal,
  SetShowAddRtwAttachmentModal,
  UpdateRtwSuccess,
  SetRtwDraftAssignments,
  ChangeAddFileInProgress,
  GetRTWLiveProcesses,
  GetRTWLiveProcessesSuccess,
  GetRTWLiveProcessesError,
  GetRTWPendingProcesses,
  GetRTWPendingProcessesSuccess,
  GetRTWPendingProcessesError,
  GetRTWDraftProcesses,
  GetRTWDraftProcessesSuccess,
  GetRTWDraftProcessesError,
  SetRTWLiveProcessesFilter,
  UpdateRtw,
  UpdateRtwError,
  DisableRtw,
  DisableRtwSuccess,
  DisableRtwError,
  AddRtw,
  AddRtwSuccess,
  AddRtwError,
} from "@modules/service/constants/actions";
import * as serviceReducers from "./reducers";
import initialState from "./state";
import type { RtwStateType } from "./types";
import { cloneObject } from "@utils/object";

export default (state: RtwStateType = initialState, action: Object): RtwStateType => {
  const act = {
    [SetRTWLiveProcessesFilter]: serviceReducers.onSetRTWLiveProcessesFilter,
    [GetRTWLiveProcesses]: serviceReducers.onGetRTWLiveProcesses,
    [GetRTWLiveProcessesSuccess]: serviceReducers.onGetRTWLiveProcessesSuccess,
    [GetRTWLiveProcessesError]: serviceReducers.onGetRTWLiveProcessesError,

    [DisableRtw]: serviceReducers.onDisableRtw,
    [DisableRtwSuccess]: serviceReducers.onDisableRtwSuccess,
    [DisableRtwError]: serviceReducers.onDisableRtwError,

    [AddRtw]: serviceReducers.onAddRtw,
    [AddRtwSuccess]: serviceReducers.onAddRtwSuccess,
    [AddRtwError]: serviceReducers.onAddRtwError,

    [GetRTWPendingProcesses]: serviceReducers.onGetRTWPendingProcesses,
    [GetRTWPendingProcessesSuccess]: serviceReducers.onGetRTWPendingProcessesSuccess,
    [GetRTWPendingProcessesError]: serviceReducers.onGetRTWPendingProcessesError,

    [GetRTWDraftProcesses]: serviceReducers.onGetRTWDraftProcesses,
    [GetRTWDraftProcessesSuccess]: serviceReducers.onGetRTWDraftProcessesSuccess,
    [GetRTWDraftProcessesError]: serviceReducers.onGetRTWDraftProcessesError,

    [GetRtw]: serviceReducers.onGet,
    [GetRtwSuccess]: serviceReducers.onGetSuccess,
    [GetRtwError]: serviceReducers.onGetError,
    [GetRtwSchema]: serviceReducers.onGetSchema,
    [GetRtwSchemaSuccess]: serviceReducers.onGetSchemaSuccess,
    [GetRtwSchemaError]: serviceReducers.onGetSchemaError,
    [NewRtw]: serviceReducers.onNew,
    [DuplicateRtwSuccess]: serviceReducers.onDuplicateSuccess,
    [StartDraftRtwSuccess]: serviceReducers.onStartDraftSuccess,
    [SetRtwDraft]: serviceReducers.onSetDraft,
    [NewRtwAssignments]: serviceReducers.onNewAssignments,
    [SetRtwAssignments]: serviceReducers.onSetAssignments,
    [SetRtwDraftAssignments]: serviceReducers.onSetRtwDraftAssignments,
    [SetRtwEnabled]: serviceReducers.onSetEnabled,
    [SetRtwStatus]: serviceReducers.onSetStatus,
    [SetRtwModalStep]: serviceReducers.onSetModalStep,
    [SetShowAddRtwModal]: serviceReducers.onSetShowAddModal,
    [SetShowEditRtwModal]: serviceReducers.onSetShowEditModal,
    [SetShowEditRtwAssignmentsModal]: serviceReducers.onSetShowEditAssignmentsModal,
    [SetShowDiscardRtwModal]: serviceReducers.onSetShowDiscardModal,
    [SetShowSubmitRtwModal]: serviceReducers.onSetShowSubmitModal,
    [SetShowDisableRtwModal]: serviceReducers.onSetShowDisableModal,
    [SetShowCancelRtwModal]: serviceReducers.onSetShowCancelModal,
    [SetShowCancelRtwModal]: serviceReducers.onSetShowCancelModal,
    [SetShowCancelDiscardRtwModal]: serviceReducers.onSetShowCancelDiscardModal,
    [SetShowAddRtwAttachmentModal]: serviceReducers.onSetShowAddRtwAttachmentModal,
    [ChangeAddFileInProgress]: serviceReducers.onChangeAddFileInProgress,
    [UpdateRtw]: serviceReducers.onUpdateRtw,
    [UpdateRtwError]: serviceReducers.onUpdateRtwError,
    [UpdateRtwSuccess]: serviceReducers.onUpdateRtwSuccess,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
